var exports = {
  "Mf": "xe533113f--583f93--tab",
  "vW": "xe533113f--583f93--inner",
  "qw": "xe533113f--583f93--tab--active",
};

module.exports = exports;
